import { Box } from '@mui/material';
import { createSelector } from '@reduxjs/toolkit';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { UbosForm } from '../../components/ubos-form';
import { selectnextStep } from '../../reducers/next-step';

const selector = createSelector([selectnextStep], (nextStep) => ({
  loading: nextStep.loading,
}));

const PreCollectUbosPage: FC = () => {
  const { loading } = useSelector(selector);

  return (
    !loading && (
      <WizardPage
        title={
          <Box maxWidth="sm" mx="auto">
            Tell us more about owners and executives
          </Box>
        }
        footer={<YouCanComeBackNote />}
      >
        <UbosForm submitLabel="Continue" attestationVerb="continuing" submitAction="pre_collect_ubos" />
      </WizardPage>
    )
  );
};

export { PreCollectUbosPage };
